import React from 'react';
import { Grid, Typography } from '@mui/material';

interface ReferralPayoutHeaderProps {
  title?: string;
  subtitle?: string;
}

const ReferralPayoutHeader: React.FC<ReferralPayoutHeaderProps> = ({
  title = 'Referral Payouts',
  subtitle = 'Review and manage referral payouts'
}) => {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          {title}
        </Typography>
        <Typography variant="subtitle2">{subtitle}</Typography>
      </Grid>
    </Grid>
  );
};

export default ReferralPayoutHeader;
